export default {"src":"/_next/static/media/setting-goals-calendar.mono.e4bd4d57.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};